( ( $ ) => {
	"use strict";
	$( '.consoles-slider' ).each( ( el ) => {
		$( '.consoles-slider__slides', el ).slick( {
			arrows: false,
			dots: true,
			fade: true,
			autoplay: true,
			autoplaySpeed: 5000,
			mobileFirst: true,
			speed: 500,
			appendArrows: $( '.consoles-slider__controls .arrows', el ),
			appendDots: $( '.consoles-slider__controls .dots', el ),
			responsive: [
				{
					breakpoint: 768,
					settings: {
						dots: false,
						arrows: true
					}
				}
			]
		} );
	} )


} )( jQuery );